import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { TeamMember } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 2460. 自分のチームメンバー一覧
 * [GET] /workspaces/:identifier/me/team_members
 */
type Props = {
  identifier: string;
};
const meTeamMembers = (props: Props): Promise<TeamMember[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/me/team_members`);
};

export const useMeTeamMembers = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => meTeamMembers(props),
  });
};

export const useMeTeamMembersInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'me', 'team_members'];
};
